import { Bar } from 'react-chartjs-2';
import 'chart.js/auto';
import {useSelector} from "react-redux";
import {dashboardSelector} from "../../../../../redux/slices/dashboardSlice";
import s from './newBarCharts.module.scss'

const options = {
    plugins: { legend: { display: false } },
    scales: {
        x: {
            ticks: { color: '#fff', maxRotation: 45, minRotation: 45 },
            grid: { display: false }
        },
        y: {
            ticks: { color: '#ccc' },
            grid: {
                borderDash: [5, 5],
                color: '#444'
            }
        }
    }
};


const NewBarCharts = () => {

    const {topAppsList} = useSelector(dashboardSelector);

    const data = {
        labels: topAppsList.map(o => o.app),
        datasets: [{
            data: topAppsList.map(o => o.installs),
            backgroundColor: topAppsList.map(o => '#476CFF'),
        }]
    };

    return (
        <div className={s.chartBarWrapper}>
            <Bar
                data={data}
                options={{
                    ...options,

                    maintainAspectRatio: false,
                    responsive: true,
                }}
                style={{height: 470}}
            />
        </div>
    )
}

export default NewBarCharts;